var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLi = function SvgLi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.003.776C1.6.776.683 1.698.683 2.908c0 1.184.89 2.132 2.266 2.132h.027c1.43 0 2.32-.948 2.32-2.132-.027-1.21-.89-2.132-2.293-2.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.925 6.724h4.101v12.338h-4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.092 6.435c-2.212 0-3.696 2.078-3.696 2.078V6.724h-4.1v12.338h4.1v-6.89c0-.369.027-.737.135-1 .297-.737.971-1.5 2.104-1.5 1.484 0 2.078 1.131 2.078 2.79v6.6h4.1v-7.074c0-3.79-2.023-5.553-4.721-5.553z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/li.e7b19468.svg";
export { ForwardRef as ReactComponent };